import { shopUidParam } from './shared/constants/end-point-constants';
import { CreatorAppConfig } from './shared/models/creator-app-config.model';
export const appConfig: CreatorAppConfig = {
  contentShellConfig: {
    authResponseType: 'code',
    authScope: 'openid',
    authCodeChallengeMethod: 'S256',
    authRedirectionPath: `/mylist/${shopUidParam}/checkout/auth/occ/res`
  },
  sharedConfig: {
    availableLanguages: [
      {
        label: 'ไทย',
        code: 'th',
        selected: false
      },
      {
        label: 'English',
        code: 'en',
        selected: false
      }
    ],
    defaultLanguage: 'th',
    currencySymbol: '฿',
    thousandSeparator: ',',
    facebookShareBaseUrl: 'https://www.facebook.com/sharer/sharer.php?u=',
    lineShareBaseUrl: 'https://social-plugins.line.me/lineit/share?url=',
    lineShareOnMobileBaseUrl: 'https://line.me/R/share?text=',
    socialShareContextPath: '/mylist/share/key/',
    captchaScriptUrl: 'https://www.google.com/recaptcha/api.js?onload=reCaptchaLoad&render=explicit',
    authServerContext: '/authorizationserver/oauth/token',
    returnPolicyUrl: 'https://www.amway.co.th/return-policy-2019',
    cancelPolicyUrl: 'https://www.amway.co.th/order-cancellation-refunds-2019',
    trackOrderContextPath: '/delivery-tracking',
    aboFee: 900,
    memberFee: 100,
    skipErrorCodes: ['ecom-val-cart-1016', 'ECOMM-Error-Otp-006', 'ECOMM-Error-Otp-005', '-201224', '-201207',
      '-200652', '-200649', '-200647', '200654', '-200651', '-200650', '-200653']
  },
  owlCarouselConfig: {
    shoplistCardCarousel: {
      loop: false,
      touchDrag: true,
      lazyLoad: true,
      dots: false,
      nav: true,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      skip_validateItems: true,
      navText: ['<div class=\'favorite-list-card-arrow favorite-list-card-arrow-prev\'></div>',
        '<div class=\'favorite-list-card-arrow favorite-list-card-arrow-next\'></div>'],
      responsive: {
        0: {
          items: 3,
          margin: 4,
          nav: false
        },
        767: {
          items: 4,
          margin: 4
        },
        1024: {
          margin: 10,
          items: 4
        },
        1199: {
          margin: 10,
          items: 4
        }
      }
    },
    productInfoCarousel: {
      items: 1,
      loop: false,
      touchDrag: true,
      lazyLoad: true,
      dots: true,
      nav: false,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      skip_validateItems: true
    },
    themesCarousel: {
      loop: false,
      touchDrag: true,
      dots: false,
      nav: false,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      skip_validateItems: true,
      responsive: {
        0: {
          items: 4
        },
        520: {
          items: 6
        },
        660: {
          items: 8
        }
      }
    }
  },
  cartConfig: {
    memberRegistrationValue: 100,
    aboRegistrationValue: 900
  }
};
